<script>
    export default {
        name: "VueDataTableFormBaseElement",
        props: {
            value: undefined,
            text: undefined,
            read: undefined,
            // 기본적으로 편집불가능한 요소 입니다.
            editable: {
                type: Boolean,
                default: false,
            },
            option: {
                type: Object,
                default: () => {},
            },
            item: undefined,
        },
        data() {
            return {
                model: this.value,
            };
        },
        computed: {
        },
        watch: {
            value(newValue, oldValue) {
                if (!this.checkDirty(newValue, oldValue)) return;
                this.model = this.value;
            },

            model() {
                this.$emit("input", this.model);
            },
        },
        methods: {
            /**
             * value가 변경될 때 더티체크를 수행합니다. 반환 값이 false 이면 값을 변경하지 않습니다.
             * @return Boolean
             */
            checkDirty(newValue, oldValue) {
                return true;
            },
        },
    }
</script>